/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_DescInputs */

const cs_order_desc = /** @type {(inputs: Order_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sestupně`)
};

const en_order_desc = /** @type {(inputs: Order_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descending`)
};

/**
* | output |
* | --- |
* | "Descending" |
*
* @param {Order_DescInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_desc = /** @type {((inputs?: Order_DescInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_DescInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_desc(inputs)
	return cs_order_desc(inputs)
});